/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BindingInfo from './BindingInfo';

/**
 * The ParameterDescriptor model module.
 * @module model/ParameterDescriptor
 * @version V1
 */
class ParameterDescriptor {
    /**
     * Constructs a new <code>ParameterDescriptor</code>.
     * @alias module:model/ParameterDescriptor
     */
    constructor() { 
        
        ParameterDescriptor.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ParameterDescriptor</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ParameterDescriptor} obj Optional instance to populate.
     * @return {module:model/ParameterDescriptor} The populated <code>ParameterDescriptor</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ParameterDescriptor();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('parameterType')) {
                obj['parameterType'] = ApiClient.convertToType(data['parameterType'], 'String');
            }
            if (data.hasOwnProperty('bindingInfo')) {
                obj['bindingInfo'] = BindingInfo.constructFromObject(data['bindingInfo']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ParameterDescriptor</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ParameterDescriptor</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['parameterType'] && !(typeof data['parameterType'] === 'string' || data['parameterType'] instanceof String)) {
            throw new Error("Expected the field `parameterType` to be a primitive type in the JSON string but got " + data['parameterType']);
        }
        // validate the optional field `bindingInfo`
        if (data['bindingInfo']) { // data not null
          BindingInfo.validateJSON(data['bindingInfo']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
ParameterDescriptor.prototype['name'] = undefined;

/**
 * @member {String} parameterType
 */
ParameterDescriptor.prototype['parameterType'] = undefined;

/**
 * @member {module:model/BindingInfo} bindingInfo
 */
ParameterDescriptor.prototype['bindingInfo'] = undefined;






export default ParameterDescriptor;

